import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { announcement, searchBtn, logo, cartCount, cartBtn } = zelektor(node)
    const { womenPage, menPage } = node.dataset
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'
    const siteHeader = document.querySelector('header.header')

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('gender:set', ({ gender }) => {
        setGender(gender)
    })

    ctx.on('gender:setTemp', ({ gender }) => {
        setGender(gender)
    })

    node.addEventListener('mouseout', leaveHeader)

    searchBtn.addEventListener('click', () => {
        ctx.emit('search:open')
    })

    cartBtn.addEventListener('click', (e) => {
        e.preventDefault()
        toggleCartDrawer(e)
    })

    ctx.on('cart:updated', (state) => {
        updateCartCount(state.cart.item_count)
    })

  
    const fixHeaderObserver = new IntersectionObserver(
        (entries) => {
            fixHeaderOnScroll(entries)
        },
        {
            threshold: 0,
        }
    )

    fixHeaderObserver.observe(announcement)

    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()

    function init() {
        setBodyPaddingTop()
        if (gender) setGender(gender)
        updateCartCount(ctx.getState().cart.item_count)
        setLogoUrl()
    }

    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function setBodyPaddingTop() {
        document.body.style.paddingTop = `${announcement.offsetHeight}px`
    }

    function leaveHeader(e) {
        if (siteHeader.className.match(/\bgender--men\b/) || siteHeader.className.match(/\bgender--women\b/)) {
            const parent = e.currentTarget
            const children = [...parent.getElementsByTagName('*')]

            if (children.indexOf(e.relatedTarget) === -1) {
                setGender(localStorage.getItem('spreeglee_gender') || 'unisex')
            }
        }
    }

    function setGender(gender) {
        node.classList.remove('gender--women')
        node.classList.remove('gender--men')
        node.classList.remove('gender--unisex')

        node.classList.add(`gender--${gender}`)
    }

    function setLogoUrl() {
        const gender = localStorage.getItem('spreeglee_gender')
        if (gender) logo.href = gender === 'women' ? womenPage : menPage
    }

    function toggleCartDrawer(e) {
        e.preventDefault()

        ctx.emit('cart:toggle', (state) => {
            return {
                cartOpen: !state.cartOpen,
            }
        })
    }

    function updateCartCount(count) {
        count > 0 ? (cartCount.innerText = count) : (cartCount.innerText = '')
    }

    function fixHeaderOnScroll(entries) {
        entries[0].boundingClientRect.bottom < 0 ? node.classList.add('is-fixed') : node.classList.remove('is-fixed')
    }
})
